module.exports = __webpack_public_path__ + "img/Profile.cb763321.svg";